module.exports = require("babel-runtime/helpers/classCallCheck");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/helpers/classCallCheck"
// module id = 3
// module chunks = 0